// Deployment config the Rails layout injects on window. Read it through here so callers don't
// depend on where it comes from once the SPA is served without Rails.

export type DeploymentEnvironment = "development" | "sandbox" | "production";

export function getDeploymentEnvironment(): DeploymentEnvironment {
  if (window.environment !== "production") {
    return "development";
  }
  return window.SANDBOX_NAME ? "sandbox" : "production";
}

export function getSandboxName(): string | null {
  return window.SANDBOX_NAME ?? null;
}
